/* global axios */
import ApiClient from './ApiClient';

const client = new ApiClient('external_credentials', { accountScoped: true });

export const externalCredentialsAPI = {
  list: params => axios.get(client.url, { params }),
  templates: () => axios.get(`${client.url}/templates`),
  show: id => axios.get(`${client.url}/${id}`),
  create: data => axios.post(client.url, { external_credential: data }),
  update: (id, data) =>
    axios.patch(`${client.url}/${id}`, { external_credential: data }),
  delete: id => axios.delete(`${client.url}/${id}`),
  test: id => axios.post(`${client.url}/${id}/test`),
};
